import { Menu } from "../models/MenuModels/index";

// **This has been replaced by capi message of globalTVG4MenuItems

export default (domain, brand = "tvg") => {
  const menuItems = [
    new Menu("Racing", "/races", {}, "", [], "racingButton"),
    new Menu(
      "Handicapping",
      "/handicapping/handicapping-store",
      {},
      "",
      [],
      "handicappingButton"
    ),
    new Menu(
      "Support Center",
      "https://support.tvg.com",
      "newWindow",
      "",
      [],
      "helpButton"
    ),
    new Menu(
      "Watch FDTV",
      `https://${domain}/live`,
      "newWindow",
      "sideMenuButton",
      [],
      "watchLiveButton",
      "video"
    )
  ];
  return menuItems;
};
